import axios from 'axios';
import { baseApi, token } from '../../../services/Apis';

export const descuentosApi = `${baseApi}/discounts`;

export const getAllDescuentosService = async (params) => {
  const res = await axios.get(descuentosApi, {
    headers: await token({}),
    params,
  });
  return res;
};

export const saveDescuentosService = async (id, data) => {
  if (data.file) {
    const formData = new FormData();

    if (data.userTypes?.length) {
      for (const userType of data.userTypes) {
        formData.append('userTypes[]', userType);
      }
      delete data.userTypes;
    }
    Object.keys(data).forEach((key) => {
      formData.append(key, data[key]);
    });
    data = formData;
  } else {
    delete data.file;
  }

  let res;
  if (id) {
    res = await axios.put(`${descuentosApi}/${id}`, data, {
      headers: await token({
        isFormData: !!data.file,
      }),
    });
  } else {
    res = await axios.post(`${descuentosApi}`, data, {
      headers: await token({
        isFormData: !!data.file,
      }),
    });
  }
  return res.data;
};

export const getOneDescuentosService = async (id) => {
  const res = await axios.get(`${descuentosApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};

export const deleteDescuentosService = async (id) => {
  const res = await axios.delete(`${descuentosApi}/${id}`, {
    headers: await token({}),
  });
  return res;
};
